import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = { class: "applied" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { class: "applied-contents" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "image-area" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "project-title" }
const _hoisted_8 = { class: "project-post-date" }
const _hoisted_9 = { class: "state" }
const _hoisted_10 = {
  key: 0,
  class: "no-data"
}
const _hoisted_11 = ["src"]

import { useRouter } from "vue-router";
import { nextTick, ref, onBeforeUnmount, watch } from "vue";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import {
  APPLICATION_STATE,
  APPLIED_TAB_LIST,
  APPLICATION_STATE_NAME,
  NO_DATA,
} from "../consts/common";
import Tabs from "./Tabs.vue";
import dayjs from "dayjs";


export default /*@__PURE__*/_defineComponent({
  __name: 'Applied',
  setup(__props) {

const projectStore = ProjectStore();
const infiteScroll = ref([false, false, false]);

const loading = ref(true);
const commonStore = CommonStore();
const selectedStatus = ref<number>(1);
const preselectedStatus = ref<number>(-1);
const displayList = ref(
  projectStore.appliedProjectList.get(projectStore.selectedStatus) || []
);

// DOM削除する前に既読情報更新
onBeforeUnmount(() => {
  if (
    projectStore.selectedStatus > 0 &&
    openedTab(projectStore.selectedStatus)
  ) {
    projectStore.readNotification({ step: projectStore.selectedStatus - 1 });
  }
});

const displayStatus = (state: number) => {
  return APPLICATION_STATE_NAME.find((v) => v.state == state)?.name;
};
// スクロール位置の保持、無限スクロール
const handleScroll = async () => {
  const container = document.getElementsByClassName(
    "applied-contents-item-selection"
  )[0] as HTMLElement;

  setScrollHeight(projectStore.selectedStatus);
  // setScrollHeight(projectStore.selectedStatus);
  if (projectStore.appliedAllCalled[projectStore.selectedStatus - 1]) return;
  if (loading.value || infiteScroll.value[projectStore.selectedStatus - 1])
    return;
  if (!container || !container.scrollHeight) return

  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    120
  )
    return;

  loading.value = true;
  const initLoading = document.getElementsByClassName(
    "loading"
  )[0] as HTMLElement;
  initLoading.style.top =
    container.offsetTop + container.scrollHeight - 50 + "px";

  const pageNum = projectStore.appliedProjectListPageNum + 1;
  projectStore.setAppliedProjectListPageNum(pageNum);
  infiteScroll.value[projectStore.selectedStatus - 1] = true;

  await projectStore.getAppliedProjects(projectStore.selectedStatus);
  infiteScroll.value[projectStore.selectedStatus - 1] = false;
  displayList.value =
    projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
  loading.value = false;
};
const setScrollHeight = (selectedStatus: number) => {
  const item = document.getElementsByClassName(
    "applied-contents-item-selection"
  )[0] as HTMLElement;
  if (!item) return
  switch (selectedStatus) {
    case APPLICATION_STATE.APPLIED:
      commonStore.setAppliedProjectScrollHeight(
        projectStore.selectedStatus,
        item.scrollTop
      );
      break;
    case APPLICATION_STATE.WON:
      commonStore.setAppliedProjectScrollHeight(
        projectStore.selectedStatus,
        item.scrollTop
      );
      break;
    case 3:
      commonStore.setAppliedProjectScrollHeight(
        projectStore.selectedStatus,
        item.scrollTop
      );
      break;
  }
};
const getScrollHeight = () => {
  displayList.value =
    projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
  const item = document.getElementsByClassName(
    "applied-contents-item-selection"
  )[0] as HTMLElement;
  if (!item) return;
  item.scrollTo({
    top: commonStore.getAppliedProjectScrollHeight.get(
      projectStore.selectedStatus
    ),
    behavior: "auto",
  });
};

// 日付をYYYY年MM月DD日にフォーマットして返す
const setDiaplayDate = (date: string) => {
  return dayjs(new Date(date)).format("YYYY年MM月DD日");
};

const hiddenLoading = () => {
  if (!loading.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

// 応募前: 0, 応募済: 1, 当選済: 2, 下書き送信済: 3, 投稿済: 4, 確認済: 5, 完了: 6, 落選: 10, キャンセル: 11, 応募不可: 12

const getProjectList = async (id: number) => {
  loading.value = true;
  await projectStore.getAppliedProjects(id).then(() => {
    displayList.value = projectStore.appliedProjectList.get(id) || [];
    loading.value = false;
  });
};

function openedTab(id: number) {
  switch (id) {
    case 1:
      return projectStore.notification.applied;
    case 2:
      return projectStore.notification.progress;
    case 3:
      return projectStore.notification.completed;
  }
}

const router = useRouter();
document.title = "応募案件";

async function tabChange(id: number) {
  if (preselectedStatus.value > 0 && openedTab(preselectedStatus.value)) {
    projectStore.readNotification({ step: preselectedStatus.value - 1 });
  }
  loading.value = true;

  displayList.value = [];

  preselectedStatus.value = selectedStatus.value;
  selectedStatus.value = id;
  projectStore.setSelectedStatus(id);
  // 初期表示済であれば一覧APIは呼ばない
  if (
    projectStore.appliedProjectList.get(projectStore.selectedStatus)?.length
  ) {
    displayList.value =
      projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
    loading.value = false;
  } else {
    await getProjectList(id);
  }
  await nextTick(() => {
    getScrollHeight();
  });
}
// const store = ProjectStore();

const detail = (id: number) => {
  projectStore.setSelectedId(id);
  router.push("/applied-project-detail");
};

watch(
  projectStore.appliedProjectList,
  () => {
    if (projectStore.appliedProjectList.get(projectStore.selectedStatus)) {
      displayList.value =
        projectStore.appliedProjectList.get(projectStore.selectedStatus) || [];
    }
  },

  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(commonStore).getupDatingToast.showToast ? 'l-modal__bg' : ''])
    }, null, 2 /* CLASS */),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Tabs, {
          onTabchange: _cache[0] || (_cache[0] = ($event: any) => (tabChange($event))),
          "tab-name1": _unref(APPLIED_TAB_LIST).get(1).name,
          "tab-name2": _unref(APPLIED_TAB_LIST).get(2).name,
          "tab-name3": _unref(APPLIED_TAB_LIST).get(3).name,
          applied: _unref(projectStore).notification.applied,
          progress: _unref(projectStore).notification.progress,
          completed: _unref(projectStore).notification.completed
        }, null, 8 /* PROPS */, ["tab-name1", "tab-name2", "tab-name3", "applied", "progress", "completed"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("section", {
          class: "applied-contents-item-selection",
          key: selectedStatus.value,
          onScroll: _cache[1] || (_cache[1] = ($event: any) => (handleScroll()))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayList.value, (data, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("ul", {
                class: "product-img-wrap",
                onClick: ($event: any) => (detail(data.id))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: data.image
                  }, null, 8 /* PROPS */, _hoisted_6),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(data.title), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_8, " 投稿期間: " + _toDisplayString(setDiaplayDate(data.post_started_at)) + " 〜 " + _toDisplayString(setDiaplayDate(data.post_ended_at)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(displayStatus(data.aplication_state)), 1 /* TEXT */)
                    ])
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_4)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _withDirectives(_createElementVNode("div", {
            style: _normalizeStyle(hiddenLoading()),
            class: _normalizeClass([
            displayList.value && displayList.value.length > 0 ? 'loading' : 'first-loading',
          ])
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
          ]), 6 /* CLASS, STYLE */), [
            [_vShow, loading.value]
          ])
        ], 32 /* NEED_HYDRATION */)),
        _createCommentVNode(" </transition> ")
      ]),
      (!loading.value && !displayList.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _unref(NO_DATA).get(_unref(projectStore).selectedStatus).img
            }, null, 8 /* PROPS */, _hoisted_11)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})